import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../services';

@Component({
  selector: 'aup-sign-out',
  templateUrl: './sign-out.component.html',
  styleUrls: ['./sign-out.component.scss'],
  standalone: false,
})
export class SignOutComponent implements OnInit {
  private authService = inject(AuthService);

  ngOnInit() {
    this.authService.isDoneLoading$.subscribe(isDoneLoading => {
      if (isDoneLoading) {
        this.authService.logout();
      }
    });
  }
}
